import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
const principles = ['Connecting strategic ambition with execution: aligning customers, people, technology, capital and organizational capability around clear business priorities.', 'Broad enterprise perspective shaped by international growth, commercial leadership, operational transformation, strategic partnerships and financial discipline.', 'Leadership style: Direct, hands-on and accountable. Stays close to customers and market realities, challenges assumptions, reassesses priorities when conditions change and focuses organizations on sustainable value.', 'Particularly effective in complex environments where growth depends on making clear choices, strengthening organizational capability and translating strategy into measurable business outcomes.'];
export function About() {
  return <section id="about" className="bg-white py-24 lg:py-32" data-id="element-16" data-mp="3rg16iv9ynri6">
      <div className="max-w-content mx-auto px-6 lg:px-10 grid lg:grid-cols-[1fr_1fr] gap-16" data-id="element-17" data-mp="3rehniwwx72cp">
        <div data-id="element-18" data-mp="2louqf0ingfc6">
          <SectionHeading eyebrow="01. About" title="A Global Leadership Identity" data-id="element-19" data-mp="2gs4dun6201vi" />
          <p className="mt-6 text-base leading-relaxed text-slate-600 max-w-xl" data-id="element-20" data-mp="2guh0veqo52ff">
            Stephanie Meyer is an international executive with more than 25 years of experience leading
            growth, transformation and commercial performance across Europe, North America, Latin America
            and Asia.
          </p>

          <div className="mt-10 pt-8 border-t border-slate-200 max-w-xl" data-id="element-21" data-mp="30flim9o5lgft">
            <span className="text-xs font-semibold tracking-[0.2em] uppercase text-gold-dark" data-id="element-22" data-mp="30ihii3jkaf6w">
              Language Proficiency
            </span>
            <p className="mt-3 text-sm text-slate-700" data-id="element-23" data-mp="2qp8wwe4lrh83">
              Native Luxembourgish&nbsp;&nbsp;|&nbsp;&nbsp;Fluent English, French, German.
            </p>
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-slate-50 border border-slate-200 p-8 lg:p-10" data-id="element-24" data-mp="3jdy3gsofger8">
          <span className="text-xs font-semibold tracking-[0.2em] uppercase text-gold-dark" data-id="element-25" data-mp="3ti4qzrte3cm6">
            Leadership Principles
          </span>
          <ul className="mt-6 space-y-4" data-id="element-26" data-mp="1cr4eaacv70s">
            {principles.map(item => <li key={item} className="flex items-start gap-3 text-sm leading-relaxed text-slate-600" data-id="element-27" data-mp="3jmtab3yf7vbs">
                <span className="mt-2 h-1.5 w-1.5 rounded-full bg-gold shrink-0" data-id="element-28" data-mp="3ohqkie7fsaq9" />
                {item}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}